// Shared helper for "is this exit currently shown on this node?".
//
// Fallback order:
//   1. If the node has a stored NodeExit row, use its isActive flag
//      (NodeExit rows exist for every connected exit AND for any placeholder
//      the user activated via the properties panel).
//   2. Otherwise fall back to ModuleExit.showByDefault (defaulting to true
//      when the column hasn't been migrated yet — keeps the old "show all"
//      behaviour for legacy databases).
//
// Note: an exit that is currently connected (has an edge) is always rendered
// regardless of the flag, because hiding a connected handle would orphan the
// edge visually. Callers enforce that rule separately; this helper only
// answers the pure visibility question.

import type { ModuleExit } from './types';

export function isExitActive(
  exit: Pick<ModuleExit, 'showByDefault'>,
  stored: boolean | undefined
): boolean {
  if (stored === false) return false;
  if (stored === true) return true;
  return exit.showByDefault !== false;
}
